module.exports = __webpack_public_path__ + "img/glasses-11.000ebf1e.svg";